import { CommonModule } from '@angular/common'
import { Component, EventEmitter, inject, Input, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { Client } from '../../control-panel.service'
import { MatButtonModule } from '@angular/material/button'
import { NgxMaskPipe } from 'ngx-mask'
import { Store } from '@ngrx/store'
import { ClientActions } from '@monorepo-channels/channels/domain'
import { ConciergeEditProfileComponent } from './edit-profile/edit-profile.component'
import { MatDialog } from '@angular/material/dialog'

@Component({
	standalone: true,
	selector: 'feature-pm-clients-tab-content',
	templateUrl: './tab-clients.component.html',
	styleUrls: ['./tab-clients.component.scss'],
	imports: [MatTableModule, CommonModule, MatIconModule, MatButtonModule, NgxMaskPipe],
})
export class TabClientsComponent {
	@Input() isLoadingLogin!: boolean
	@Input() dataSource!: MatTableDataSource<Client>
	@Input() displayedColumns!: string[]
	@Output() clientUpdated = new EventEmitter<void>()
	private store = inject(Store)
	private dialog = inject(MatDialog)

	get selectedClientId(): string | null {
		return localStorage.getItem('clientId')
	}

	loginClient(data: Client) {
		this.store.dispatch(
			ClientActions.loginClientByEmailAndPhone({ email: data.email, phone: data.phone })
		)
		this.clientUpdated.emit()
	}

	editClient(client: Client) {
		const dialogRef = this.dialog.open(ConciergeEditProfileComponent, {
			width: '500px',
			maxHeight: '90vh',
			data: client,
			disableClose: true,
		})
		dialogRef.afterClosed().subscribe(result => {
			if (result === 'updated') {
				this.clientUpdated.emit()
			}
		})
	}
}
